import { useState } from 'react';
import { Input, Button, Tag, Typography, Popconfirm, message } from 'antd';
import { UserAddOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

// UsuariosCliente es la lista de personas que compran como un cliente (una
// empresa con varios compradores), con el alta por mail. Lo usan el detalle del
// cliente en el admin y el perfil del propio cliente.
//
// agregar(mail) y quitar(id) devuelven la respuesta del server; esUnoMismo(u)
// esconde el botón de quitar para el que está mirando.
export const UsuariosCliente = ({ usuarios, agregar, quitar, esUnoMismo = () => false, ayuda }) => {
  const [mail, setMail] = useState('');
  const [agregando, setAgregando] = useState(false);

  const enviar = async () => {
    if (!mail.trim()) return;
    setAgregando(true);
    try {
      const res = await agregar(mail.trim());
      if (res.status === 'success') {
        message.success(res.data?.pendiente
          ? 'Listo. Cuando entre a la web con ese mail ya va a estar adentro.'
          : 'Usuario agregado');
        setMail('');
      } else {
        message.error(res.message || 'No se pudo agregar');
      }
    } finally {
      setAgregando(false);
    }
  };

  const sacar = async (u) => {
    const res = await quitar(u.id);
    if (res.status === 'success') message.success('Usuario quitado');
    else message.error(res.message || 'No se pudo quitar');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {ayuda && <Text type="secondary" style={{ fontSize: 13 }}>{ayuda}</Text>}

      {usuarios.length === 0 ? (
        <Text type="secondary" style={{ fontSize: 13 }}>Todavía nadie compra con este cliente desde la web.</Text>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {usuarios.map((u, i) => {
            const nombre = [u.nombre, u.apellido].filter(Boolean).join(' ');
            return (
              <div key={u.id} style={{
                display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0',
                borderTop: i === 0 ? 'none' : '1px solid #f0f0f0',
              }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 14 }}>{nombre || u.usuario}</div>
                  {nombre && <Text type="secondary" style={{ fontSize: 12 }}>{u.usuario}</Text>}
                </div>
                {u.pendiente && <Tag>Todavía no entró</Tag>}
                {!esUnoMismo(u) && (
                  <Popconfirm
                    title="¿Quitar a este usuario?"
                    description="Deja de ver los pedidos y de comprar con este cliente."
                    okText="Quitar"
                    cancelText="Cancelar"
                    onConfirm={() => sacar(u)}
                  >
                    <Button type="text" danger icon={<DeleteOutlined />} aria-label="Quitar usuario" />
                  </Popconfirm>
                )}
              </div>
            );
          })}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <Input
          type="email"
          placeholder="mail@empresa.com"
          value={mail}
          onChange={(e) => setMail(e.target.value)}
          onPressEnter={enviar}
          style={{ flex: '1 1 220px' }}
        />
        <Button icon={<UserAddOutlined />} loading={agregando} onClick={enviar}>Agregar</Button>
      </div>
    </div>
  );
};
